/* ══════════════════════════════════════════════════════
   BILINGUAL STRINGS  (EN / FR)
══════════════════════════════════════════════════════ */
const MSC_I18N = {
  en: {
    badge:'🌟 Real Astronomical Precision',
    title1:'Your', title2:'Moon', title3:'Sign',
    sub:'Calculate the exact position of the Moon at the moment of your birth using certified astronomical formulas.',
    formCalc:'Calculate', formRest:'My Moon Sign',
    labelEmail:'Email address', placeholderEmail:'you@example.com',
    labelDate:'Date of birth', labelTime:'Time of birth', labelPlace:'Place of birth',
    placeholderPlace:'e.g. Tunis, Tunisia',
    btnText:'Calculate My Moon Sign', btnLoading:'Calculating…',
    resTitle:'Your Moon Sign', calcFor:'Calculated for',
    posKey1:'Ecliptic longitude', posKey2:'Position in sign', posKey3:'Approximate distance',
    traitsTitle:'✦ Your Lunar Traits',
    errEmailRequired:'Please enter your email address.',
    errEmailInvalid:'Please enter a valid email address.',
    errDate:'Please enter your date of birth.',
    errTime:'Please enter the time of birth.',
    errPlace:'Please enter the place of birth.',
    errNotFound:'Location not found.',
    errCalc:'Lunar calculation failed.',
    moonSign:'Moon Sign',
    traits:{
      Aries:{el:'Fire',qu:'Cardinal',ru:'Mars',
        t1:'Emotional Nature',d1:'Impulsive, passionate and spontaneous. You react with intensity and frankness.',
        t2:'Instinctive Reactions',d2:'Competitive, independent and action-oriented. You lead instinctively.',
        t3:'Comfort Zone',d3:'Physical activity, challenges and being first. Security through achievement.',
        t4:'Shadow Side',d4:'Impatience, selfishness and emotional immaturity.'},
      Taurus:{el:'Earth',qu:'Fixed',ru:'Venus',
        t1:'Emotional Nature',d1:'Stable, sensual and security-seeking. You need stability and comfort.',
        t2:'Instinctive Reactions',d2:'Patient, practical and possessive. You resist change.',
        t3:'Comfort Zone',d3:'Beautiful surroundings, good food and pleasures. Peace in luxury.',
        t4:'Shadow Side',d4:'Stubbornness, materialism and resistance to necessary change.'},
      Gemini:{el:'Air',qu:'Mutable',ru:'Mercury',
        t1:'Emotional Nature',d1:'Curious, adaptable and mentally restless. Emotions change as fast as your thoughts.',
        t2:'Instinctive Reactions',d2:'Communicative, social and intellectually driven. You process emotions through talking.',
        t3:'Comfort Zone',d3:'Learning, variety and social interaction. Mental stimulation is essential.',
        t4:'Shadow Side',d4:'Inconsistency, superficiality and emotional detachment.'},
      Cancer:{el:'Water',qu:'Cardinal',ru:'Moon',
        t1:'Emotional Nature',d1:'Nurturing, sensitive and deeply intuitive. Excellent emotional memory.',
        t2:'Instinctive Reactions',d2:'Protective, caring and family-oriented. Instinctively creates emotional security.',
        t3:'Comfort Zone',d3:'Home, family and emotional intimacy. Comfort in the familiar.',
        t4:'Shadow Side',d4:'Moodiness, clinginess and tendency to hold grudges.'},
      Leo:{el:'Fire',qu:'Fixed',ru:'Sun',
        t1:'Emotional Nature',d1:'Dramatic, generous and attention-seeking. Need for recognition.',
        t2:'Instinctive Reactions',d2:'Creative, playful and leadership-oriented. Reacts with flair.',
        t3:'Comfort Zone',d3:'Being admired, creative expression and centre stage.',
        t4:'Shadow Side',d4:'Pride, ego-centricity and emotional drama.'},
      Virgo:{el:'Earth',qu:'Mutable',ru:'Mercury',
        t1:'Emotional Nature',d1:'Analytical, helpful and perfectionist. Processes emotions through practical service.',
        t2:'Instinctive Reactions',d2:'Critical, organised and health-conscious. Instinctively wants to improve everything.',
        t3:'Comfort Zone',d3:'Order, usefulness and self-improvement. Security through productivity.',
        t4:'Shadow Side',d4:'Over-criticism, worry and excessive perfectionism.'},
      Libra:{el:'Air',qu:'Cardinal',ru:'Venus',
        t1:'Emotional Nature',d1:'Harmonious, diplomatic and relationship-focused. Needs balance and beauty.',
        t2:'Instinctive Reactions',d2:'Cooperative, fair-minded and peace-seeking. Instinctively creates harmony.',
        t3:'Comfort Zone',d3:'Beautiful environments, partnerships and social harmony.',
        t4:'Shadow Side',d4:'Indecisiveness, people-pleasing and conflict avoidance.'},
      Scorpio:{el:'Water',qu:'Fixed',ru:'Pluto/Mars',
        t1:'Emotional Nature',d1:'Intense, passionate and transformative. Feels emotions deeply.',
        t2:'Instinctive Reactions',d2:'Investigative, powerful and regenerative. Probes beneath the surface.',
        t3:'Comfort Zone',d3:'Deep connections, mystery and transformation.',
        t4:'Shadow Side',d4:'Jealousy, possessiveness and obsessive tendencies.'},
      Sagittarius:{el:'Fire',qu:'Mutable',ru:'Jupiter',
        t1:'Emotional Nature',d1:'Optimistic, adventurous and freedom-loving. Needs space and variety.',
        t2:'Instinctive Reactions',d2:'Philosophical, honest and expansive. Reacts with enthusiasm.',
        t3:'Comfort Zone',d3:'Travel, learning and philosophical discussions.',
        t4:'Shadow Side',d4:'Restlessness, tactlessness and commitment issues.'},
      Capricorn:{el:'Earth',qu:'Cardinal',ru:'Saturn',
        t1:'Emotional Nature',d1:'Ambitious, disciplined and goal-oriented. Security through achievement.',
        t2:'Instinctive Reactions',d2:'Practical, responsible and authoritative. Instinctively builds and succeeds.',
        t3:'Comfort Zone',d3:'Structure, achievement and respect.',
        t4:'Shadow Side',d4:'Coldness, rigidity and workaholism.'},
      Aquarius:{el:'Air',qu:'Fixed',ru:'Uranus/Saturn',
        t1:'Emotional Nature',d1:'Independent, humanitarian and unconventional. Needs intellectual freedom.',
        t2:'Instinctive Reactions',d2:'Innovative, detached and group-oriented. Reacts with originality.',
        t3:'Comfort Zone',d3:'Friendship, innovation and social causes.',
        t4:'Shadow Side',d4:'Emotional detachment, rebelliousness and unpredictability.'},
      Pisces:{el:'Water',qu:'Mutable',ru:'Neptune/Jupiter',
        t1:'Emotional Nature',d1:'Compassionate, intuitive and dreamy. Absorbs emotions from others.',
        t2:'Instinctive Reactions',d2:'Empathetic, creative and escape-seeking. Instinctively wants to help and heal.',
        t3:'Comfort Zone',d3:'Spiritual practices, creativity and emotional connection.',
        t4:'Shadow Side',d4:'Escapism, victim mentality and emotional confusion.'}
    }
  },
  fr: {
    badge:'🌟 Précision Astronomique Réelle',
    title1:'Votre', title2:'Signe', title3:'Lunaire',
    sub:'Calculez la position exacte de la Lune au moment de votre naissance grâce à des formules astronomiques certifiées.',
    formCalc:'Calculer', formRest:'Mon Signe Lunaire',
    labelEmail:'Adresse email', placeholderEmail:'vous@exemple.com',
    labelDate:'Date de naissance', labelTime:'Heure de naissance', labelPlace:'Lieu de naissance',
    placeholderPlace:'ex: Tunis, Tunisie',
    btnText:'Calculer Mon Signe Lunaire', btnLoading:'Calcul en cours…',
    resTitle:'Votre Signe Lunaire', calcFor:'Calculé pour',
    posKey1:'Longitude écliptique', posKey2:'Position dans le signe', posKey3:'Distance approximative',
    traitsTitle:'✦ Vos Traits Lunaires',
    errEmailRequired:'Veuillez entrer votre adresse email.',
    errEmailInvalid:'Veuillez entrer une adresse email valide.',
    errDate:'Veuillez entrer votre date de naissance.',
    errTime:"Veuillez entrer l'heure de naissance.",
    errPlace:'Veuillez entrer le lieu de naissance.',
    errNotFound:'Lieu introuvable.',
    errCalc:'Calcul lunaire échoué.',
    moonSign:'Signe Lunaire',
    traits:{
      Aries:{el:'Feu',qu:'Cardinal',ru:'Mars',
        t1:'Nature Émotionnelle',d1:'Impulsive, passionnée et spontanée. Vous réagissez avec intensité et franchise.',
        t2:'Réactions Instinctives',d2:'Compétitive, indépendante et orientée action. Vous menez instinctivement.',
        t3:'Zone de Confort',d3:'Activité physique, défis et être premier. Sécurité par l\'accomplissement.',
        t4:'Ombre',d4:'Impatience, égoïsme et immaturité émotionnelle.'},
      Taurus:{el:'Terre',qu:'Fixe',ru:'Vénus',
        t1:'Nature Émotionnelle',d1:'Stable, sensuelle et cherchant la sécurité. Besoin de stabilité et confort.',
        t2:'Réactions Instinctives',d2:'Patient, pratique et possessif. Vous résistez au changement.',
        t3:'Zone de Confort',d3:'Beaux environnements, bonne nourriture et plaisirs. Paix dans le luxe.',
        t4:'Ombre',d4:'Entêtement, matérialisme et résistance au changement nécessaire.'},
      Gemini:{el:'Air',qu:'Mutable',ru:'Mercure',
        t1:'Nature Émotionnelle',d1:'Curieuse, adaptable et mentalement agitée. Émotions changeantes comme vos pensées.',
        t2:'Réactions Instinctives',d2:'Communicatif, social et intellectuellement motivé. Traite les émotions par la parole.',
        t3:'Zone de Confort',d3:'Apprentissage, variété et interaction sociale. Stimulation mentale nécessaire.',
        t4:'Ombre',d4:'Inconstance, superficialité et détachement émotionnel.'},
      Cancer:{el:'Eau',qu:'Cardinal',ru:'Lune',
        t1:'Nature Émotionnelle',d1:'Nourricière, sensible et profondément intuitive. Excellente mémoire affective.',
        t2:'Réactions Instinctives',d2:'Protecteur, attentionné et centré sur la famille. Crée la sécurité émotionnelle.',
        t3:'Zone de Confort',d3:'Foyer, famille et intimité émotionnelle. Confort dans le familier.',
        t4:'Ombre',d4:'Humeurs changeantes, possessivité et tendance à garder rancune.'},
      Leo:{el:'Feu',qu:'Fixe',ru:'Soleil',
        t1:'Nature Émotionnelle',d1:'Dramatique, généreux et cherchant l\'attention. Besoin de reconnaissance.',
        t2:'Réactions Instinctives',d2:'Créatif, joueur et orienté leadership. Réagit avec panache.',
        t3:'Zone de Confort',d3:'Être admiré, expression créative et être au centre.',
        t4:'Ombre',d4:'Orgueil, égocentrisme et drame émotionnel.'},
      Virgo:{el:'Terre',qu:'Mutable',ru:'Mercure',
        t1:'Nature Émotionnelle',d1:'Analytique, serviable et perfectionniste. Traite les émotions par le service pratique.',
        t2:'Réactions Instinctives',d2:'Critique, organisé et soucieux. Veut améliorer instinctivement tout.',
        t3:'Zone de Confort',d3:'Ordre, utilité et amélioration personnelle. Sécurité par la productivité.',
        t4:'Ombre',d4:'Sur-critique, inquiet et perfectionnisme excessif.'},
      Libra:{el:'Air',qu:'Cardinal',ru:'Vénus',
        t1:'Nature Émotionnelle',d1:'Harmonieux, diplomatique et axé relations. Besoin d\'équilibre et de beauté.',
        t2:'Réactions Instinctives',d2:'Coopératif, équitable et cherchant la paix. Crée l\'harmonie instinctivement.',
        t3:'Zone de Confort',d3:'Beaux environnements, partenariats et harmonie sociale.',
        t4:'Ombre',d4:'Indécision, complaisance et évitement des conflits.'},
      Scorpio:{el:'Eau',qu:'Fixe',ru:'Pluton/Mars',
        t1:'Nature Émotionnelle',d1:'Intense, passionné et transformateur. Ressent les émotions profondément.',
        t2:'Réactions Instinctives',d2:'Investigateur, puissant et régénérateur. Sonde sous la surface.',
        t3:'Zone de Confort',d3:'Connexions profondes, mystère et transformation.',
        t4:'Ombre',d4:'Jalousie, possessivité et tendances obsessionnelles.'},
      Sagittarius:{el:'Feu',qu:'Mutable',ru:'Jupiter',
        t1:'Nature Émotionnelle',d1:'Optimiste, aventurier et amoureux de la liberté. Besoin d\'espace et variété.',
        t2:'Réactions Instinctives',d2:'Philosophique, honnête et expansif. Réagit avec enthousiasme.',
        t3:'Zone de Confort',d3:'Voyage, apprentissage et discussions philosophiques.',
        t4:'Ombre',d4:'Agitation, maladresse et problèmes d\'engagement.'},
      Capricorn:{el:'Terre',qu:'Cardinal',ru:'Saturne',
        t1:'Nature Émotionnelle',d1:'Ambitieux, discipliné et orienté objectifs. Sécurité par l\'accomplissement.',
        t2:'Réactions Instinctives',d2:'Pratique, responsable et autoritaire. Construit et réussit instinctivement.',
        t3:'Zone de Confort',d3:'Structure, accomplissement et respect.',
        t4:'Ombre',d4:'Froideur, rigidité et bourreau de travail.'},
      Aquarius:{el:'Air',qu:'Fixe',ru:'Uranus/Saturne',
        t1:'Nature Émotionnelle',d1:'Indépendant, humanitaire et non conventionnel. Besoin de liberté intellectuelle.',
        t2:'Réactions Instinctives',d2:'Innovant, détaché et orienté groupe. Réagit avec originalité.',
        t3:'Zone de Confort',d3:'Amitié, innovation et causes sociales.',
        t4:'Ombre',d4:'Détachement émotionnel, rébellion et imprévisibilité.'},
      Pisces:{el:'Eau',qu:'Mutable',ru:'Neptune/Jupiter',
        t1:'Nature Émotionnelle',d1:'Compatissant, intuitif et rêveur. Absorbe les émotions des autres.',
        t2:'Réactions Instinctives',d2:'Empathique, créatif et cherchant à fuir. Veut aider et guérir.',
        t3:'Zone de Confort',d3:'Pratiques spirituelles, créativité et connexion émotionnelle.',
        t4:'Ombre',d4:'Évasion, mentalité de victime et confusion émotionnelle.'}
    }
  }
};

/* Detect language from Shopify locale */
function mscGetLang(){
  const loc=(document.documentElement.lang||'en').toLowerCase();
  return loc.startsWith('fr')?'fr':'en';
}
let MSC_LANG=mscGetLang();
let MSC_T=MSC_I18N[MSC_LANG];

function mscApplyLang(){
  MSC_T=MSC_I18N[MSC_LANG];
  document.getElementById('msc-badge-text').textContent=MSC_T.badge;
  document.getElementById('msc-title-accent').textContent=MSC_T.title2;
  document.getElementById('msc-title-sign').textContent=MSC_T.title3;
  const h1=document.querySelector('.msc-hero-title');
  if(h1) h1.childNodes[0].textContent=MSC_T.title1+' ';
  document.getElementById('msc-hero-sub').textContent=MSC_T.sub;
  document.getElementById('msc-form-title-calc').textContent=MSC_T.formCalc;
  document.getElementById('msc-form-title-rest').textContent=MSC_T.formRest;
  document.getElementById('msc-label-email').textContent=MSC_T.labelEmail;
  document.getElementById('msc-email').placeholder=MSC_T.placeholderEmail;
  document.getElementById('msc-label-date').textContent=MSC_T.labelDate;
  document.getElementById('msc-label-time').textContent=MSC_T.labelTime;
  document.getElementById('msc-label-place').textContent=MSC_T.labelPlace;
  document.getElementById('msc-birthPlace').placeholder=MSC_T.placeholderPlace;
  document.getElementById('msc-btn-text').textContent=MSC_T.btnText;
  document.getElementById('msc-pos-key1').textContent=MSC_T.posKey1;
  document.getElementById('msc-pos-key2').textContent=MSC_T.posKey2;
  document.getElementById('msc-pos-key3').textContent=MSC_T.posKey3;
  document.getElementById('msc-traits-title').textContent=MSC_T.traitsTitle;
  if(document.getElementById('msc-res-title-text'))
    document.getElementById('msc-res-title-text').textContent=MSC_T.resTitle;
}
mscApplyLang();

/* Watch for Shopify language switcher changes */
const mscLangObserver=new MutationObserver(()=>{
  const newLang=mscGetLang();
  if(newLang!==MSC_LANG){MSC_LANG=newLang;mscApplyLang()}
});
mscLangObserver.observe(document.documentElement,{attributes:true,attributeFilter:['lang']});

/* ══════════════════════════════════════════════════════
   ZODIAC SVG SYMBOLS — inline, no external image needed
══════════════════════════════════════════════════════ */
const MSC_SVG={
  Aries:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG)" font-family="serif">♈</text><defs><linearGradient id="mscG" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Taurus:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG2)" font-family="serif">♉</text><defs><linearGradient id="mscG2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Gemini:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG3)" font-family="serif">♊</text><defs><linearGradient id="mscG3" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Cancer:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG4)" font-family="serif">♋</text><defs><linearGradient id="mscG4" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e1cba4"/></linearGradient></defs></svg>`,
  Leo:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG5)" font-family="serif">♌</text><defs><linearGradient id="mscG5" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Virgo:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG6)" font-family="serif">♍</text><defs><linearGradient id="mscG6" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Libra:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG7)" font-family="serif">♎</text><defs><linearGradient id="mscG7" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Scorpio:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG8)" font-family="serif">♏</text><defs><linearGradient id="mscG8" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e1cba4"/></linearGradient></defs></svg>`,
  Sagittarius:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG9)" font-family="serif">♐</text><defs><linearGradient id="mscG9" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Capricorn:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG10)" font-family="serif">♑</text><defs><linearGradient id="mscG10" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`,
  Aquarius:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG11)" font-family="serif">♒</text><defs><linearGradient id="mscG11" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e1cba4"/></linearGradient></defs></svg>`,
  Pisces:`<svg class="msc-sign-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><text y="72" x="50" text-anchor="middle" font-size="72" fill="url(#mscG12)" font-family="serif">♓</text><defs><linearGradient id="mscG12" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a45e"/><stop offset="100%" stop-color="#e6d3b3"/></linearGradient></defs></svg>`
};

/* ══════════════════════════════════════════════════════
   STARFIELD
══════════════════════════════════════════════════════ */
(function(){
  const c=document.getElementById('msc-stars');
  if(!c)return;
  const ctx=c.getContext('2d');
  const root=c.parentElement;
  function resize(){c.width=root.offsetWidth;c.height=root.offsetHeight||window.innerHeight}
  window.addEventListener('resize',resize,{passive:true});resize();
  const N=320;
  const stars=Array.from({length:N},()=>({
    x:Math.random()*c.width,y:Math.random()*c.height,
    r:Math.random()*1.6+.2,o:Math.random()*.7+.15,
    s:Math.random()*.3+.04,
    twinkleSpeed:Math.random()*.02+.005,twinklePhase:Math.random()*Math.PI*2
  }));
  let frame=0;
  (function loop(){
    requestAnimationFrame(loop);
    ctx.clearRect(0,0,c.width,c.height);frame+=0.016;
    stars.forEach(s=>{
      s.y+=s.s;if(s.y>c.height){s.y=0;s.x=Math.random()*c.width}
      const tw=s.o*(0.6+0.4*Math.sin(frame/s.twinkleSpeed+s.twinklePhase));
      ctx.beginPath();ctx.arc(s.x,s.y,s.r,0,2*Math.PI);
      ctx.fillStyle=`rgba(255,255,255,${tw})`;ctx.fill();
    });
  })();
})();

/* ══════════════════════════════════════════════════════
   GEOCODING — inchangée
══════════════════════════════════════════════════════ */
const mscGeoCache={};
async function mscGetCoords(placeName){
  if(mscGeoCache[placeName])return mscGeoCache[placeName];
  try{
    const r=await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(placeName)}&limit=1`);
    const d=await r.json();
    if(d&&d.length>0){
      const c={latitude:parseFloat(d[0].lat),longitude:parseFloat(d[0].lon),name:d[0].display_name};
      mscGeoCache[placeName]=c;return c;
    }
    throw new Error(MSC_T.errNotFound);
  }catch(e){throw new Error(MSC_T.errNotFound)}
}

/* ══════════════════════════════════════════════════════
   MOON SIGN CALCULATION — logique métier inchangée
══════════════════════════════════════════════════════ */
function mscCalcMoonSign(date){
  try{
    const jd=mscJulianDay(date);
    const T=(jd-2451545.0)/36525.0;
    const L=mscNorm(218.3164477+481267.88123421*T-0.0015786*T*T+T*T*T/538841.0-T*T*T*T/65194000.0);
    const D=mscNorm(297.8501921+445267.1114034*T-0.0018819*T*T+T*T*T/545868.0-T*T*T*T/113065000.0);
    const M=mscNorm(357.5291092+35999.0502909*T-0.0001536*T*T+T*T*T/24490000.0);
    const Mp=mscNorm(134.9633964+477198.8675055*T+0.0087414*T*T+T*T*T/69699.0-T*T*T*T/14712000.0);
    const F=mscNorm(93.2720950+483202.0175233*T-0.0036539*T*T-T*T*T/3526000.0+T*T*T*T/863310000.0);
    let sigmL=0;
    [[0,0,1,0,6288774],[2,0,-1,0,1274027],[2,0,0,0,658314],[0,0,2,0,213618],[0,1,0,0,-185116],
     [0,0,0,2,-114332],[2,0,-2,0,58793],[2,-1,-1,0,57066],[2,0,1,0,53322],[2,-1,0,0,45758],
     [0,1,-1,0,-40923],[1,0,0,0,-34720],[0,1,1,0,-30383],[2,0,0,-2,15327],[0,0,1,2,-12528],
     [0,0,1,-2,10980],[4,0,-1,0,10675],[0,0,3,0,10034],[4,0,-2,0,8548],[2,1,-1,0,-7888],
     [2,1,0,0,-6766],[1,0,-1,0,-5163],[1,1,0,0,4987],[2,-1,1,0,4036],[2,0,2,0,3994],
     [4,0,0,0,3861],[2,0,-3,0,3665],[0,1,-2,0,-2689],[2,0,-1,2,-2602],[2,-1,-2,0,2390]
    ].forEach(t=>{
      sigmL+=t[4]*Math.sin((t[0]*D+t[1]*M+t[2]*Mp+t[3]*F)*Math.PI/180);
    });
    const lon=mscNorm(L+sigmL/1000000.0);
    const idx=Math.floor(lon/30);
    const deg=lon%30;
    const names=['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
    return{sign:names[idx],degree:deg,eclipticLongitude:lon,distance:384400};
  }catch(e){throw new Error(MSC_T.errCalc)}
}
function mscJulianDay(date){
  const a=Math.floor((14-(date.getMonth()+1))/12);
  const y=date.getFullYear()+4800-a;
  const m=(date.getMonth()+1)+12*a-3;
  let jd=date.getDate()+Math.floor((153*m+2)/5)+365*y+Math.floor(y/4)-Math.floor(y/100)+Math.floor(y/400)-32045;
  return jd+((date.getHours()+date.getMinutes()/60+(date.getSeconds()||0)/3600)/24)-0.5;
}
function mscNorm(a){a=a%360;if(a<0)a+=360;return a}

/* ══════════════════════════════════════════════════════
   DISPLAY
══════════════════════════════════════════════════════ */
function mscDisplay(moonData,coords,birthDate,birthTime){
  const st=MSC_T.traits[moonData.sign];

  /* Inline SVG symbol — no external image, always visible */
  document.getElementById('msc-sign-svg-wrap').innerHTML=MSC_SVG[moonData.sign]||'';

  document.getElementById('msc-sign-name').textContent=moonData.sign;
  document.getElementById('msc-sign-subtitle').textContent=`${MSC_T.moonSign} • ${{Aries:'♈',Taurus:'♉',Gemini:'♊',Cancer:'♋',Leo:'♌',Virgo:'♍',Libra:'♎',Scorpio:'♏',Sagittarius:'♐',Capricorn:'♑',Aquarius:'♒',Pisces:'♓'}[moonData.sign]}`;
  document.getElementById('msc-sign-meta').innerHTML=`
    <span class="msc-pill msc-pill-element">🔥 ${st.el}</span>
    <span class="msc-pill msc-pill-quality">◈ ${st.qu}</span>
    <span class="msc-pill msc-pill-ruler">♆ ${st.ru}</span>`;
  document.getElementById('msc-calc-info').textContent=
    `${MSC_T.calcFor} ${coords.name} — ${birthDate} ${MSC_LANG==='fr'?'à':'at'} ${birthTime}. ${MSC_T.posKey1}: ${moonData.eclipticLongitude.toFixed(2)}° (${moonData.degree.toFixed(1)}° ${moonData.sign})`;
  document.getElementById('msc-pos-longitude').textContent=`${moonData.eclipticLongitude.toFixed(2)}°`;
  document.getElementById('msc-pos-degree').textContent=`${moonData.degree.toFixed(1)}° ${moonData.sign}`;
  document.getElementById('msc-pos-distance').textContent=`${moonData.distance.toLocaleString()} km`;
  document.getElementById('msc-res-date').textContent=`${MSC_T.calcFor} ${birthDate}`;
  document.getElementById('msc-res-title-text').textContent=MSC_T.resTitle;
  document.getElementById('msc-traits-title').textContent=MSC_T.traitsTitle;

  document.getElementById('msc-traits').innerHTML=
    `<div class="msc-trait-item"><h4>${st.t1}</h4><p>${st.d1}</p></div>
     <div class="msc-trait-item"><h4>${st.t2}</h4><p>${st.d2}</p></div>
     <div class="msc-trait-item"><h4>${st.t3}</h4><p>${st.d3}</p></div>
     <div class="msc-trait-item"><h4>${st.t4}</h4><p>${st.d4}</p></div>`;

  const r=document.getElementById('msc-result');
  r.style.display='block';
  setTimeout(()=>r.scrollIntoView({behavior:'smooth',block:'start'}),100);
}

/* ══════════════════════════════════════════════════════
   CRM EXTERNE (SUPABASE) — envoi direct depuis le navigateur
   ⚠️ Mêmes identifiants que dans moon-phase-calculator.liquid
══════════════════════════════════════════════════════ */
const MSC_SUPABASE_URL = 'https://ugdwbpxqldpgopubzfse.supabase.co';
const MSC_SUPABASE_ANON_KEY = 'sb_publishable_fxjaQzwxEN-4jN_A3yVx5Q_dRwOuEgT';

function sendToExternalCRM(payload){
  fetch(`${MSC_SUPABASE_URL}/rest/v1/rpc/upsert_customer`,{
    method:'POST',
    headers:{
      'content-type':'application/json',
      'apikey': MSC_SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${MSC_SUPABASE_ANON_KEY}`
    },
    body:JSON.stringify({
      p_email:          payload.email,
      p_city:           payload.ville,
      p_country:        payload.pays,
      p_birth_date:     payload.date_naissance,
      p_source:         payload.source,
      p_custom_fields:  payload.champs_personnalises
    })
  }).catch(()=>{ /* échec silencieux — ne bloque jamais l'UX */ });
}

/* ══════════════════════════════════════════════════════
   FORM LOGIC
══════════════════════════════════════════════════════ */
(function(){
  const btn=document.getElementById('msc-fetch-btn');
  const spinner=document.getElementById('msc-spinner');
  const btnMoon=document.getElementById('msc-btn-moon');
  const btnTxt=document.getElementById('msc-btn-text');
  const errBox=document.getElementById('msc-error');

  function setLoading(on){
    spinner.style.display=on?'block':'none';
    btnMoon.style.display=on?'none':'inline';
    btnTxt.textContent=on?MSC_T.btnLoading:MSC_T.btnText;
    btn.disabled=on;
  }
  function showErr(msg){
    errBox.textContent=msg;errBox.style.display='block';
    setTimeout(()=>errBox.style.display='none',7000);
  }
  function clearErr(){
    errBox.style.display='none';
    ['msc-email','msc-birthDate','msc-birthTime','msc-birthPlace'].forEach(id=>{
      const el=document.getElementById(id);if(el)el.classList.remove('msc-error');
    });
  }

  btn.addEventListener('click',async function(){
    const email=document.getElementById('msc-email').value.trim();
    const birthDate=document.getElementById('msc-birthDate').value;
    const birthTime=document.getElementById('msc-birthTime').value;
    const birthPlace=document.getElementById('msc-birthPlace').value.trim();
    clearErr();
    if(!email){document.getElementById('msc-email').classList.add('msc-error');showErr(MSC_T.errEmailRequired);document.getElementById('msc-email').focus();return}
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){document.getElementById('msc-email').classList.add('msc-error');showErr(MSC_T.errEmailInvalid);document.getElementById('msc-email').focus();return}
    if(!birthDate){document.getElementById('msc-birthDate').classList.add('msc-error');showErr(MSC_T.errDate);document.getElementById('msc-birthDate').focus();return}
    if(!birthTime){document.getElementById('msc-birthTime').classList.add('msc-error');showErr(MSC_T.errTime);document.getElementById('msc-birthTime').focus();return}
    if(!birthPlace){document.getElementById('msc-birthPlace').classList.add('msc-error');showErr(MSC_T.errPlace);document.getElementById('msc-birthPlace').focus();return}
    setLoading(true);
    try{
      const coords=await mscGetCoords(birthPlace);
      const dt=new Date(`${birthDate}T${birthTime}:00`);
      const moonData=mscCalcMoonSign(dt);
      mscDisplay(moonData,coords,birthDate,birthTime);

      // ── ENVOI DIRECT VERS LE CRM EXTERNE ────────────────────
      sendToExternalCRM({
        email:           email,
        ville:           birthPlace,
        pays:            (coords.name||'').split(',').pop().trim() || null,
        date_naissance:  birthDate,
        source:          'moon-sign',
        date_visite:     new Date().toISOString(),
        champs_personnalises:{
          signe_lunaire:          moonData.sign,
          longitude_ecliptique:   moonData.eclipticLongitude.toFixed(2)+'°',
          position_dans_signe:    moonData.degree.toFixed(1)+'° '+moonData.sign,
          distance_km:            moonData.distance,
          heure_naissance:        birthTime,
          lieu_complet:           coords.name
        }
      });
      // ─────────────────────────────────────────────────────────
    }catch(e){showErr(e.message);}
    finally{setLoading(false);}
  });

  document.getElementById('msc-birthDate').max=new Date().toISOString().split('T')[0];
})();